/**
 * FERP Portal - Trace List Page (DRR-074: Tabulator DRY Template)
 *
 * MONITOR Phase: Execution traces and lineage.
 * Delegates to TabulatorPrimitiveManager for consistent CRUD across all 25 primitives.
 */

import { TabulatorPrimitiveManager } from '@/components/primitives/TabulatorPrimitiveManager';

export function TraceListPage() {
  return <TabulatorPrimitiveManager primitiveType="trace" />;
}

export default TraceListPage;
